module.exports = __webpack_public_path__ + "img/retired-2015-medal.aacdba29.jpg";